/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function GiftIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="gift"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M4.5 11L19.5 11L19.5 18.5C19.5 19.605 18.605 20.5 17.5 20.5L6.5 20.5C5.395 20.5 4.5 19.605 4.5 18.5L4.5 11Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M3.5 9.25C3.5 8.284 4.284 7.5 5.25 7.5L18.75 7.5C19.716 7.5 20.5 8.284 20.5 9.25C20.5 10.216 19.716 11 18.75 11L5.25 11C4.284 11 3.5 10.216 3.5 9.25Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M12 11L12 20.5" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M12 7.5L13.28 4.62C13.718 3.635 14.695 3 15.773 3L16.25 3C17.493 3 18.5 4.007 18.5 5.25C18.5 6.493 17.493 7.5 16.25 7.5L12 7.5Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M12 7.5L10.72 4.62C10.282 3.635 9.305 3 8.227 3L7.75 3C6.507 3 5.5 4.007 5.5 5.25C5.5 6.493 6.507 7.5 7.75 7.5L12 7.5Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
